export const SETTINGS_VIEW_LIST = [
  {
    displayName: "DateTime",
    name: "settings-date-format",
  },
  {
    displayName: "Workflow History",
    name: "settings-workflow-history",
  },
];
